<script>
/**
 * ****************************************************************************
 * @description     :   Input Postcode Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from '@/utils/repository';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input file component
 */
var BsPostCode = {
    template: template,
    props: {
        id: String,
        label: {
            type: String,
            default: '郵便番号'
        },
        itemClass: String,
        labelClass: String,
        inputClass: String,
        placeholder: {
            type: String,
            default: '000-0000'
        },
        modelValue: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChange: Function,
        onSearch: Function,
        isDisabledIcon: Boolean
    },
    emits: ['update:modelValue'],
    computed: {
        postalno: {
            get() {
                return this.modelValue;
            },
            set(newVal) {
                this.$emit('update:modelValue', newVal);
                if (this.onChange) {
                    this.onChange(newVal);
                }
            }
        }
    },
    methods: {
        doPostalClick() {
            let postalno = this.modelValue;
            postalno = postalno?.replace('-', '');
            repository
                .get(`/common/zipcode?zipcode=${postalno}`)
                .then((res) => {
                    const { data } = res;
                    let address = '';
                    if (data.Code === 200) {
                        address = `${data.Data.address1 ?? ''}${
                            data.Data.address2 ?? ''
                        }${data.Data.address3 ?? ''}`;
                    }
                    if (this.onSearch) {
                        this.onSearch(address, data.Data);
                    }
                });
        }
    }
};
export default BsPostCode;
</script>
